import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FontAwesomeEditing from "./font-awesome-editing";
import FontAwesomeUI from "./font-awesome-ui";

export default class FontAwesome extends Plugin {
    static get pluginName() {
        return 'FontAwesome';
    }

    static get requires() {
        return [ FontAwesomeEditing, FontAwesomeUI ];
    }
}